module.exports = __webpack_public_path__ + "static/media/nike-what-will-they-say-about-you.7c2b2b3c.jpg";